



























































































































































































































import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import IEventBrandingDto from "@/chipply/IEventBrandingDto";
import { DealerLogoDisplay } from "../../../../common";
import IEventCategoriesDto from "@/chipply/i-event-categories-dto";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";
import PreviewFlag from "../PreviewFlag.vue";
import PriceDisplay from "../price/PriceDisplay.vue";

@Component({
    components: {
        PreviewFlag,
        PriceDisplay,
    },
})
export default class StoreAppBar extends Vue {
    public name = "StoreAppBar";
    public DealerLogoDisplay = DealerLogoDisplay;

    // eslint-disable-next-line
    @Prop({ type: Object, default: () => {} })
    public branding!: IEventBrandingDto;

    @Prop({ type: Boolean, default: false })
    public isPreview!: boolean;

    @Prop({ type: Boolean })
    public checkout!: boolean | null;

    @Prop({ type: Number })
    public eventId!: number | null;

    @Prop({ type: Boolean })
    public showCategory!: boolean;

    @Prop({ type: Object })
    public categories!: IEventCategoriesDto;

    @Prop({ type: Number, default: 0 })
    public cartItemTotal!: number;

    @Prop({ type: Number, default: 0 })
    public cartItemCount!: number;

    public get storeName() {
        const ele = document.createElement("div");
        if (this.branding) {
            if (this.branding.slideHeader) {
                ele.innerHTML = this.branding.slideHeader;
                return ele.innerText;
            }
        }
        return "";
    }

    public get priceDisplay(): IPriceDisplay {
        return {
            displayType: this.branding.storePriceDisplayType,
            dollarValuePerPoint: this.branding.storeDollarValuePerPoint ?? 0,
        };
    }

    private get cartTarget() {
        if (this.$vuetify.breakpoint.smAndDown && this.checkout) {
            return "";
        } else {
            return "./cart.aspx?eventId=" + this.eventId;
        }
    }

    public goToStore() {
        location.assign(`/store.aspx?eid=${this.eventId}`);
    }

    public toggleDrawer() {
        this.$emit("toggleDrawer");
    }

    public toggleCatNav() {
        this.$emit("toggleCatNav");
    }
}
